import {
	CTA,
	styled,
	Text,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { InputError } from 'src/components';
import { COLOR_TOKEN } from 'src/components/color-token';
import { CTAsSiNo } from 'src/feature-app';
import { Info } from 'src/icons-core-imports';
import { CustomSwitch } from '../inputs';

const CTAsWrapper = styled.div`
	.error-field {
		width: fit-content !important;
	}

	> button {
		width: 81px;
		height: 33px;
		&:first-of-type {
			margin-right: 44px;
		}
	}
`;

const LegalItemWrapper = styled.div`
	padding-bottom: 44px;
`;

const QuestionWrapper = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	flex-wrap: nowrap;
	padding-bottom: 32px;
`;

interface InfoWrapperProps {
	formTheme?: 'main' | 'inverted';
}

const InfoWrapper = styled.div<InfoWrapperProps>`
	margin-left: 16px;
	cursor: pointer;
	svg {
		fill: ${props => COLOR_TOKEN[props.formTheme]?.content.primary};
	}
`;

export const LegalItem = ({
	title,
	onClick,
	formTheme,
	name,
	checkboxMode,
}: any) => {
	const [currentValue, setCurrentValue] = useState<string>(null);
	const { register, setValue, errors } = useFormContext();
	const [isSelected, setIsSelected] = useState(null);
	const getValue = (isSelected: boolean) =>
		isSelected ? 'PERMITE' : 'NO INFORMADO';
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch({
			type: 'UPDATE_FIELDS',
			payload: { [name]: getValue(isSelected) },
		});
	}, [isSelected]);

	useEffect(() => {
		!checkboxMode && setIsSelected(false);
	}, []);

	function checkCurrentValue(label: string, name: string) {
		const value = label === 'Sí' ? 'PERMITE' : 'NO PERMITE';
		setCurrentValue(label);
		dispatch({ type: 'UPDATE_FIELDS', payload: { [name]: value } });
		setValue(name, value);
	}

	return (
		<LegalItemWrapper>
			<QuestionWrapper>
				<Text appearance={TokenTextAppearance.copy200}>{title}</Text>
				<InfoWrapper onClick={onClick} formTheme={formTheme || 'main'}>
					<Info />
				</InfoWrapper>
			</QuestionWrapper>
			{!checkboxMode ? (
				<CTAsWrapper>
					{CTAsSiNo.map((cta: { label: string }, index: number) => (
						<CTA
							name={name}
							tag="button"
							emphasis={
								currentValue === cta.label
									? 'primary'
									: 'secondary'
							}
							ref={ref => {
								register(ref, { required: true });
							}}
							onClick={e => {
								e.preventDefault();
								checkCurrentValue(cta.label, name);
							}}
							size={'small'}
						>
							{cta.label}
						</CTA>
					))}
					{errors[name] ? (
						<InputError className="error-field">
							Este campo es obligatorio
						</InputError>
					) : null}
				</CTAsWrapper>
			) : (
				<CTAsWrapper>
					<CustomSwitch
						setSelected={setIsSelected}
						isSelected={isSelected}
					/>
					<Text color={TokenTextColor.primary}>
						{isSelected ? 'Aceptado' : 'Aceptar'}
					</Text>
				</CTAsWrapper>
			)}
		</LegalItemWrapper>
	);
};
